<template>
    <a-select
        :placeholder="$t('auto.tagPickerChooseATag')"
        class="w-100 tag-picker"
        :notFoundContent="'No tag found'"
        size="large"
        v-model="selectedTagId"
        @change="handleChange"
        @search="handleSearch"
        @select="handleSelect"
        show-search
        :filter-option="false"
    >
        <a-select-option v-for="(tag, index) of getFilteredResult()" :value="tag._id" :key="index">
            <div class="item-container">
                <div class="title">
                    <div class="logo-container">
                        <div class="circle" :style="{ 'background-color': tag.color }" />
                    </div>
                    <div class="content">{{ tag.name }}</div>
                </div>
            </div>
        </a-select-option>
    </a-select>
</template>

<script>
import { mapActions, mapState } from "vuex";
import log2 from "../../../../../../utils/log2";
import _ from "lodash";

const log = log2("TagPicker");
export default {
    name: "TagPicker",
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            loading: true,
            selectedTagId: this.value,
            query: null,
        };
    },
    computed: {
        ...mapState({
            tags: (state) => state.tag.tags.data,
        }),
    },
    methods: {
        handleChange(tagId) {
            log(`selected ${tagId}`);
            this.selectedTagId = tagId;
            this.query = "";
        },
        handleSelect(tagId) {
            log(`handleSelect ${tagId}`);
            this.selectedTagId = tagId;
        },
        handleSearch(search) {
            log(`handleSearch ${search}`);
            this.query = search;
        },
        getFilteredResult() {
            const q = (this.query || "").trim().toLowerCase();
            const result = this.tags.filter((tag) => {
                return _.isEmpty(q) || (tag.name || "").toLowerCase().includes(q);
            });
            log("getFilteredResult", result);
            return result;
        },
    },
    mounted() {
        console.log("TagPicker mounted selectedTagId", this.selectedTagId);
    },
    watch: {
        selectedTagId(newValue) {
            this.$emit("input", newValue);
        },
        value(newValue) {
            if (this.selectedTagId !== newValue) {
                this.selectedTagId = newValue;
            }
        },
    },
};
</script>

<style lang="scss">
.tag-picker {
    .ant-select-selection-selected-value {
        width: 100%;
    }

    .ant-select-selection__rendered {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .item-container {
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        align-items: center;
        width: 100%;

        .circle {
            width: 10px;
            height: 10px;
            border-radius: 50%;
        }

        .title {
            display: flex;
            align-items: center;

            .logo-container {
                .avatar {
                }
            }

            .content {
                margin-left: 10px;
                font-size: 18px;
                font-weight: 500;
            }
        }
    }
}
</style>
